<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">納入場所検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          v-permit.SHARP_WS_SEARCH
        >{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0091/new" v-permit.SHARP_WS_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_WS_EDIT.SHARP_WS_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length===0"
          @click="remove"
          v-permit.SHARP_WS_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="$t('app.warehouseTypes')"
                clearable
                label="納入場所区分"
                v-model="query.type"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="納入場所名" v-model="query.name"/>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="納入場所CD" v-model="query.code"/>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                clearable
                label="所属事業本部"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                clearable
                label="グループ"
                url="warehouse-groups/kv"
                v-model="query.groupId"
              />
            </v-flex>
            <!--
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="倉庫担当" v-model="query.warehouseManager1FullName"/>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="倉庫担当" v-model="query.warehouseManager2FullName"/>
            </v-flex>
            -->
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{props.item.code }}</td>
          <td>{{props.item.name }}</td>
          <td>{{props.item.address }}</td>
          <td>{{props.item.type }}</td>
          <td>{{props.item.buCode }}</td>
          <td>{{props.item.groupCode }}</td>
          <td>{{ props.item.receiveManager1FullName == null ? "" : props.item.receiveManager1FullName}}</td>
          <td>{{ props.item.receiveManager2FullName == null ? "" : props.item.receiveManager2FullName }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1
      },
      headers: [
        { text: '納入場所CD', value: 'code', sortable: false },
        { text: '納入場所名', value: 'name', sortable: false },
        { text: '住所', value: 'address', sortable: false },
        { text: '納入場所区分', value: 'type', sortable: false },
        { text: '所属事業本部', value: 'buCode', sortable: false },
        { text: 'グループ', value: 'group', sortable: false },
        {
          text: '倉庫担当',
          value: 'warehouseManager1FullName',
          sortable: false
        },
        {
          text: '倉庫担当',
          value: 'warehouseManager2FullName',
          sortable: false
        }
      ],
      query: {}
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/warehouses', this.params())
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    edit() {
      this.$router.push({
        name: 'EditM0091',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/warehouses/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
            this.$message('', '削除成功')
          })
        }
      )
    }
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  },
  mounted() {
    this.$loadParams()
  }
}
</script>
